import PageNav from "./components/PageNav";

export default function PrivacyPolicy() {
  return (
    <>
      <PageNav />
      <Policy />
    </>
  );
}

function Policy() {
  return (
    <div className=" flex justify-center bg-white px-6 py-10 lg:px-8">
      <div className="mx-auto max-w-3xl text-base leading-7 text-gray-700">
        <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl text-center ">
          Terms of Use And Privacy Policy
        </h1>{" "}
        {/* Gear up for an exhilarating journey of imagination and personalization with us!*/}
        <p className="mt-6 text-l leading-8">
          <div> Last Updated: Aug 5, 2025</div>
          <br />
          Thank you for visiting MyTaleMaker. We are committed to protecting
          your privacy and providing a safe online experience for children. This
          Privacy Policy outlines how we collect, use, and safeguard personal
          information, particularly from children under the age of 13, in
          accordance with the Children’s Online Privacy Protection Act (COPPA)
          and other relevant regulations.
        </p>
        <div className="mt-10 max-w-3xl">
          <ul
            role="list"
            className="list-disc mt-8 max-w-3xl space-y-8 text-gray-600 "
          >
            <li className="flex gap-x-3">
              <span>
                <strong className="font-semibold text-gray-900">
                  Usage Guidance:
                </strong>{" "}
                The process of story creation is the responsibility of an adult.
                Therefore, only an adult should be involved in sending an input
                for story creation, not a child. Children are not permitted to
                directly send input to the service. While the final product is
                intended for children's consumption, it is also intended to be
                used under adult supervision only.
              </span>
            </li>

            <li className="flex gap-x-3">
              <span>
                <strong className="font-semibold text-gray-900">
                  Content Review Responsibility:
                </strong>{" "}
                Adult users are responsible for ensuring that any content
                generated through our service is appropriate for children. Users
                must perform a thorough review of the generated stories to
                confirm they are free from profanity and other content
                inappropriate for a child audience.
              </span>
            </li>

            <li className="flex gap-x-3">
              <span>
                <strong className="font-semibold text-gray-900">
                  Prohibited Uses:
                </strong>{" "}
                Users are strictly prohibited from using MyTaleMaker to:
                <ul className="list-disc pl-5 mt-2 space-y-2">
                  <li>
                    Generate or facilitate Child Sexual Abuse Material or any
                    content that exploits or abuses minors.
                  </li>
                  <li>
                    Generate or facilitate content that is hateful, harmful, harassing,
                     or violent, including content that:
                    <ul className="list-disc pl-5 mt-2 space-y-2">
                      <li>
                        Expresses, or promotes hate or discriminatory
                        practices based on identity such as race, 
                        religion, nationality, ethnicity, gender, or sexual
                        orientation.
                      </li>
                   {/*}   <li>
                        Targets or threatens an individual with abuse,
                        practices based on identity such as race, 
                        harassment, or bullying. 
  </li> */}
                      <li>
                        Promotes or glorifies violence.
                      </li>
                      <li>
                        Encourages, or depicts acts of self-harm, such
                        as suicide.
                      </li>
                    </ul>
                  </li>
                </ul>
              </span>
            </li>

            <li className="flex gap-x-3">
              <span>
                <strong className="font-semibold text-gray-900">
                  User Input Accountability:
                </strong>{" "}
                While we may employ filters to detect and block inappropriate
                content in inputs and outputs, the responsibility for the
                appropriateness of the generated output lies with the user. If
                an adult user submits input that is not suitable for children
                and receives a corresponding output, the user assumes full
                responsibility for that content.
              </span>
            </li>

            <li className="flex gap-x-3">
              <span>
                <strong className="font-semibold text-gray-900">
                  Information Collection:
                </strong>{" "}
                We do not collect any personal information directly from a child under 13 
                years of age. All information provided by users (who must be adults as specified in our Usage Guidance) 
                for story generation purposes is done so voluntarily and is used solely for the creation of the story.
              </span>
            </li>
            <li className="flex gap-x-3">
              <span>
                <strong className="font-semibold text-gray-900">
                Third-Party Cookies and Analytics:
                </strong>{" "}
                We use cookies from Google Analytics to understand website usage and Meta (Facebook) for targeted advertising. 
                You can manage cookies through your browser settings or opt out of targeted ads via Google Ad Settings (https://adssettings.google.com) 
                and Meta Ad Preferences (in your Facebook settings). Blocking cookies may affect website functionality.

              </span>
            </li>
            <li className="flex gap-x-3">
              <span>
                <strong className="font-semibold text-gray-900">
                  Purpose of Information Usage:
                </strong>{" "}
                We only request the personal information that is essential for
                providing our services. All information provided by the user for
                story generation is only used for the story creation process. We
                do not use this information for any other purpose, and we do not
                disclose it to third parties unless required for the provision
                of our services.
              </span>
            </li>

            <li className="flex gap-x-3">
              <span>
                <strong className="font-semibold text-gray-900">
                  Data Usage And Security:
                </strong>{" "}
                We do not engage in the sale or commercial use of personal
                information. We use third-party services and APIs to provide our
                service, including story creation and payment processing, and
                may share personal information solely for provisioning our
                service. We
                strive to maintain strict confidentiality and implement security
                measures to protect the data collected; however, as no method of
                transmission over the internet or electronic storage is 100%
                secure, we cannot guarantee absolute security.
              </span>
            </li>
            <li className="flex gap-x-3">
              <span>
                <strong className="font-semibold text-gray-900">
                Physical Book Printing and Shipping Services: 
                </strong>{" "}
                When you choose to order a physical printed book of your personalized story, 
                we partner with third-party printing and fulfillment providers to 
                manufacture and deliver your custom book. For this purpose, we share the following 
                information with our printing and shipping partners:
                <ul className="list-disc pl-5 mt-2 space-y-2">
                      <li>
                      Your shipping address and contact information (name, address, phone number, email)
                      </li>
                      <li>
                      Your personalized story content and custom illustrations
                      </li>
                      <li>
                      Order details necessary for book production and delivery
                      </li>
                    </ul>
                    This information is shared solely for printing your customized book, processing and 
                    fulfilling your order, shipping the finished product, and providing delivery updates. 
                    Our third-party printing provider may retain your personalized story content for up to 
                    18 months after printing or last purchase (whichever is longer) as part of their standard 
                    content retention policy, after which it will be deleted from their systems.
              </span>
            </li>
            <li className="flex gap-x-3">
              <span>
                <strong className="font-semibold text-gray-900">
                Returns and Refunds for Physical Books: 
                </strong>{" "}
                Due to the personalized nature of our books, all physical book sales are final. 
                No returns or refunds are accepted once your order is placed, as each book is custom-created 
                specifically for your child and cannot be resold. You can review the complete story, text, 
                and images before choosing to order a physical book. MyTaleMaker is not responsible for spelling errors, 
                content preferences, or other personalization choices, as you have full preview access before ordering.

              </span>
            </li>
            <li className="flex gap-x-3">
              <span>
                <strong className="font-semibold text-gray-900">
                Returns and Refunds for Digital Content: 
                </strong>{" "}
                All credit purchases and digital stories are final and non-refundable. 
                Credits cannot be refunded whether used or unused. Digital stories cannot 
                be returned once generated.
              </span>
            </li>
            <li className="flex gap-x-3">
              <span>
                <strong className="font-semibold text-gray-900">
                  Consent to Privacy Practices:
                </strong>{" "}
                By using our website and services, you consent to the terms
                outlined in this Terms of Use And Privacy Policy.
              </span>
            </li>
            <li className="flex gap-x-3">
              <span>
                <strong className="font-semibold text-gray-900">
                  Contact Us:
                </strong>{" "}
                If you have any questions or concerns about our privacy
                practices or this Terms of Use And Privacy Policy, please
                contact us at{" "} 
                <a
                  href="mailto: contact@mytalemaker.com"
                  className="font-semibold text-gray-600 hover:text-gray-500"
                >
                  contact@mytalemaker.com
                </a>
              </span>
            </li>
            <li className="flex gap-x-3">
              <span>
                <strong className="font-semibold text-gray-900">
                  Changes to this Privacy Policy:
                </strong>{" "}
                We reserve the right to update or revise this Privacy Policy and
                Terms of Service at any time. Any changes will be posted on this
                page with the updated date. We encourage you to review this
                Privacy Policy periodically for any updates.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
